module.exports = __webpack_public_path__ + "static/img/logo_white_dang.4152934f.png";